import React from 'react';
import get from 'lodash.get';
import { createFragmentContainer, graphql } from 'react-relay';
import PropTypes from 'prop-types';
import styles from './SbSharedRelatedLinks.scss';

const SbSharedRelatedLinksItem = ({ items, title }) => {
    if (items && items.length > 0) {
        return (
            <div className={styles.item}>
                <span className={styles.title}>{title}</span>
                <ul className={styles.list}>
                    {items.map(({ name, uri }) => (
                        <li key={uri}>
                            <a href={uri} className={styles.link}>
                                {name}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
    return null;
};

SbSharedRelatedLinksItem.propTypes = {
    title: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            uri: PropTypes.string,
        })
    ),
};

const SbSharedRelatedLinkContainer = ({ searchBrowse }) => {
    const relatedLinks = get(searchBrowse, 'relatedLinks') || {};
    const relatedLinkItems = Object.keys(relatedLinks).map(key => (
        <SbSharedRelatedLinksItem key={key} {...relatedLinks[key]} />
    ));

    return <div className={styles.container}>{relatedLinkItems}</div>;
};

SbSharedRelatedLinkContainer.propTypes = {
    searchBrowse: PropTypes.object,
};

export const SbSharedRelatedLinks = createFragmentContainer(SbSharedRelatedLinkContainer, {
    searchBrowse: graphql`
        fragment SbSharedRelatedLinks_searchBrowse on SearchBrowseQueryConnection {
            relatedLinks {
                title
                items {
                    name
                    uri
                }
            }
        }
    `,
});
